<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.rav.title')"
            button
            :button-text="$t('page.rav.new')"
            button-to="rav_new"
            search
            :search-label="$t('page.rav.search')"
            @search-input="searchInputListener"
        />
        <v-row>
            <v-col cols="12">
                <TabMenu
                    v-model="menu"
                    :menus="menus"
                />
            </v-col>
            <ActionBar
                new-button
                new-to="rav_new"
                :new-label="$t('page.rav.new')"
                fetch
                :fetch-function="fetchData"
            />
            <v-col cols="12">
                <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color="primary"
                />
                <v-skeleton-loader
                    v-if="loading"
                    class="mx-auto"
                    type="table-tbody"
                />
                <RavList
                    v-if="!loading"
                    :ravs="ravs"
                    :search="textSearch"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import ActionBar from '@/components/common/ActionBar';
import PageHeader from '@/components/common/PageHeader';
import TabMenu from '@/components/common/TabMenu';
import RavList from '@/components/rav/RavList';
import RavProxy from '@/proxies/RavProxy';

import { SuccessSnackbar, ObjectDeleted } from '@/app-events.js';

export default {
    name: 'RavIndex',
    components: {
        ActionBar,
        PageHeader,
        TabMenu,
        RavList,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.rav.title'),
                    disabled: true,
                },
            ],
            menu: 'rav',
            menus: [
                {
                    id: 'rav',
                    label: 'RAV-Stelle',
                },
                {
                    id: 'rav_consultant',
                    label: 'RAV-Berater',
                    to: { name: 'rav_consultant' },
                },
            ],
            textSearch: '',
            ravs: [],
            loading: true,
        };
    },
    created () {
        this.fetchData();
        this.$eventBus.listen(ObjectDeleted, (event) => {
            this.$eventBus.dispatch(new SuccessSnackbar(this.$t('rav.actions.deleted')));
            for (let i = 0; i < this.ravs.length; i++) {
                const rav = this.ravs[ i ];
                if (rav.id === event.object.id) {
                    this.ravs.splice(i, 1);
                    break;
                }
            }
        });
    },
    methods: {
        fetchData() {
            this.loading = true;
            new RavProxy().all().then(({ data }) => {
                this.ravs = data.data;
                this.loading = false;
            }).catch(({ data }) => {
                this.displayError(data);
            });
        },
        searchInputListener(value) {
            this.textSearch = value;
        },
    },
};
</script>
